import { FamilyAccountSelectedAccountBanner } from '@eversports/react-components/patterns/FamilyAccount'
import ClientLogger from '@eversports/react-components/utilities/client-logger'
import React from 'react'
import useFamilyAccount from '../../data/useFamilyAccount'

const FamilyAccountBanner: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { loading, owner, loggedInUser, returnUrl } = useFamilyAccount()

  // If it's not a family account, don't show component
  if (loading || !owner || !loggedInUser) {
    return null
  }

  if (!returnUrl) {
    ClientLogger.warning('Tried to render a family account banner without a return url')
    return null
  }

  return <FamilyAccountSelectedAccountBanner owner={owner} loggedInUser={loggedInUser} returnUrl={returnUrl} />
}

export default React.memo(FamilyAccountBanner)
